// Facet values are human-readable names (e.g. "Blue Cross Blue Shield"), but they are also
// used to build element ids and aria-describedby references, which cannot contain whitespace.
export function facetOptionSlug(value) {
  return String(value ?? '')
    .trim()
    .replace(/['()]/g, '')
    .replace(/[^\w\s-]/g, '-')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
}
